import { useQuery } from 'react-query';
import mapKeys from 'lodash/mapKeys';
import camelCase from 'lodash/camelCase';
import api from '@API/api';
import { QueryConfig } from '@shared/api';
import { ClientPreferences } from '@shared/hooks/useClientPreferencesContext';

const getClientPreferences = async (): Promise<ClientPreferences> => {
  const response = await api.get('isAlive/env-vars');

  return mapKeys(response, (_value: boolean, key: string) =>
    camelCase(key)
  ) as ClientPreferences;
};

const useClientPreferences = (config?: QueryConfig<ClientPreferences>) => {
  // Adding a second parameter (empty object) to satisfy TS requirement
  return useQuery(['user-preferences', {}], getClientPreferences, config);
};

export default useClientPreferences;
